const moneda = 'S/';

export default moneda;
